import { CollapsingHeader } from "./CollapsingHeader";
import { CollapsingHeaderHost } from "./CollapsingHeaderHost";

export class CollapseController {
    private static controller: CollapsingHeaderHost;

    public static pushCollapsingHeader(header: CollapsingHeader): void {
        this.controller.pushCollapsingHeader(header);
    }

    public static syncNavigation(): void {
        this.controller.syncNavigation();
    }

    public static syncNavigationLeft(): void {
        this.controller.syncNavigationLeft();
    }

    public static syncNavigationRight(): void {
        this.controller.syncNavigationRight();
    }

    public static syncNavigationCenter(): void {
        this.controller.syncNavigationCenter();
    }
}
